import {collection, component, EntityData, field, identifier, reloadable} from "@fedeltapointofsale/data-client";

export class CustomObjectReferenceData extends EntityData<CustomObjectReferenceData> {
    @identifier customObjectId: number;
    @field name: string;
}

export class CustomObjectTypeReferenceData extends EntityData<CustomObjectTypeReferenceData> {
    @identifier customObjectTypeId: number;
    @field name: string;
}

export class CustomObjectCustomObjectTypeData extends EntityData<CustomObjectCustomObjectTypeData> {
    @identifier customObjectTypeId: number;
    @field name: string;
    @collection() customFields: string[];
}

export class TypedCustomObjectReferenceData extends EntityData<TypedCustomObjectReferenceData> {
    @identifier customObjectId: number;
    @field name: string;
    @component customObjectType: CustomObjectTypeReferenceData;
}

export class CustomObjectFieldValueData extends EntityData<CustomObjectFieldValueData> {
    @field fieldName: string;
    @field fieldValue: string;
}

export class CustomObjectData extends EntityData<CustomObjectData> {
    @identifier customObjectId: number;
    @field name: string;
    @field description: string;
    @field discontinued: boolean;
    @reloadable @component customObjectType: CustomObjectCustomObjectTypeData;
    @collection(CustomObjectFieldValueData) customObjectFieldValues: CustomObjectFieldValueData[];
}
